export const getTransformOrigin = (positionReferencePoint = '') => {
  const originByReferencePoint = {
    BOTTOM_CENTER: 'bottom center',
    BOTTOM_LEFT: 'bottom left',
    BOTTOM_RIGHT: 'bottom right',
    MIDDLE_CENTER: 'center center',
    MIDDLE_LEFT: 'center left',
    MIDDLE_RIGHT: 'center right',
    TOP_CENTER: 'top center',
    TOP_LEFT: 'top left',
    TOP_RIGHT: 'top right',
  };
  return originByReferencePoint[positionReferencePoint] || '';
};
